import request from '@/utils/request'
// import qs from 'qs'

// 招聘列表
export const pageList = (getData) => {
  return request({
    url: '/back/job-postings/pageList',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 招聘单个详情
export const getId = (getData) => {
  return request({
    url: '/back/job-postings/getId',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 删除
export const deleteList = (getData) => {
  return request({
    url: '/back/job-postings/deleteById',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 修改
export const updateList = (postData) => {
  return request({
    url: '/back/job-postings/update',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}

// 新增
export const addList = (postData) => {
  return request({
    url: '/back/job-postings/save',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
